import { FORMATTING_BUTTONS } from './../../editor-common';

export const desktopTextButtonList = [
  FORMATTING_BUTTONS.AI,
  '|',
  FORMATTING_BUTTONS.HEADINGS,
  '|',
  FORMATTING_BUTTONS.BOLD,
  FORMATTING_BUTTONS.ITALIC,
  FORMATTING_BUTTONS.UNDERLINE,
  FORMATTING_BUTTONS.TEXT_COLOR,
  FORMATTING_BUTTONS.TEXT_HIGHLIGHT,
  '|',
  FORMATTING_BUTTONS.LINK,
  '|',
  FORMATTING_BUTTONS.TITLE,
  FORMATTING_BUTTONS.BLOCKQUOTE,
  FORMATTING_BUTTONS.CODE_BLOCK,
  FORMATTING_BUTTONS.SPOILER,
  '|',
  // {
  //   name: 'Alignment',
  //   buttons: [ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT, ALIGN_JUSTIFY],
  // },
  FORMATTING_BUTTONS.ALIGNMENT,
  '|',
  FORMATTING_BUTTONS.ORDERED_LIST,
  FORMATTING_BUTTONS.UNORDERED_LIST,
  '|',
  FORMATTING_BUTTONS.INCREASE_INDENT,
  FORMATTING_BUTTONS.DECREASE_INDENT,
  '|',
  FORMATTING_BUTTONS.LINE_SPACING,
];

export const mobileTextButtonList = [
  'AddPlugin',
  '|',
  FORMATTING_BUTTONS.UNDO,
  FORMATTING_BUTTONS.REDO,
  '|',
  // FORMATTING_BUTTONS.HEADINGS,
  FORMATTING_BUTTONS.BOLD,
  FORMATTING_BUTTONS.ITALIC,
  FORMATTING_BUTTONS.UNDERLINE,
  FORMATTING_BUTTONS.TEXT_COLOR,
  FORMATTING_BUTTONS.TEXT_HIGHLIGHT,
  '|',
  FORMATTING_BUTTONS.LINK,
  '|',
  FORMATTING_BUTTONS.TITLE,
  FORMATTING_BUTTONS.BLOCKQUOTE,
  // FORMATTING_BUTTONS.ALIGN_LEFT,
  // FORMATTING_BUTTONS.ALIGN_CENTER,
  // FORMATTING_BUTTONS.ALIGN_RIGHT,
  // FORMATTING_BUTTONS.ALIGN_JUSTIFY,
  FORMATTING_BUTTONS.CODE_BLOCK,
  FORMATTING_BUTTONS.SPOILER,
  '|',
  FORMATTING_BUTTONS.ALIGNMENT,
  '|',
  FORMATTING_BUTTONS.ORDERED_LIST,
  FORMATTING_BUTTONS.UNORDERED_LIST,
  '|',
  // FORMATTING_BUTTONS.DECREASE_INDENT,
  // FORMATTING_BUTTONS.INCREASE_INDENT,
  FORMATTING_BUTTONS.LINE_SPACING,
];
